import './Main.css';
import logo from "./../assets/logo.png"
import twitter from "./../assets/twitter.png"
import wallet from "./../assets/wallet.png"
import mark from "./../assets/mark.png"
import copy from "./../assets/copy.png"

const buttons = [
  {
    img: twitter,
    text: "Mark Cuban Meme",
    link: "https://x.com/mcuban_meme",
  },
  {
    img: twitter,
    text: "Mark Cuban",
    link: "https://x.com/mcuban",
  },
  {
    img: wallet,
    text: "Buy now",
    link: "https://raydium.io/swap/?inputMint=sol&outputMint=CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z",
  },
];

const clickToLink = (link) => {
  window.open(link, "_blank");
};

const handleCopy = () => {
  const contract = "CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z";
  navigator.clipboard.writeText(contract);
};

export function Main() {
  return (
    <div className="main">
      <div className="header">
        <img alt='logo' src={logo} draggable={false} />
        <div className="header_buttons">
          {buttons.map((button, index) => (
            <div
              onClick={() => clickToLink(button.link)}
              className="buttons_item"
              src={button.img}
              alt={index}
              draggable={false}
              style={button.text === "Buy now" ? { backgroundColor: "#13376C", color: "white" } : undefined}
            >
              <span>{button.text}</span>
              <img src={button.img} alt={`button_${button.text}`} draggable={false} />
            </div>))}
        </div>
      </div>
      <div className="content">
        <div className="content_left">
          <div className="left_text">
            <span className='text_title'>MARK CUBAN MEME</span>
            <span className='text_description'>Join the Billionaires community now!</span>
          </div>
          <div className="left_contract">
            <div className="contract_CA">
              <span style={{ fontSize: "20px", fontWeight: "600" }}>CA:</span>
              <span onClick={handleCopy} style={{ fontSize: "10.5px", fontWeight: "400" }}>CubanZGDS1ny9rodw3oUvbL75uTxDXJwFd2uhMyU7G8z</span>
            </div>
            <img onClick={handleCopy} style={{ cursor: "pointer" }} src={copy} alt="copy" draggable={false} />
          </div>
        </div>
        <img src={mark} alt="mark" draggable={false} />
      </div>
    </div>
  );
}